import { CanvasEventType } from '../constants/Constants';
import log from 'loglevel';
import UndoManager from './UndoManager';
import { getObjectByUUID, debounce } from '../utils/utils';
import DocModuler from '../../DocModuler';

const REMOVE_ALL_PLACEHOLDER_TEXT_DELAY = 5000;
export default class Items {
  constructor() {
    this.app = null;
    this.e = {
      modifyHandler: this._modifyHandler.bind(this),
      removeHandler: this._removeHandler.bind(this),
      selectedHandler: this._selectHandler.bind(this),
      deselectedHandler: this._deselectHandler.bind(this),
      selectChangeHandler: this._selectChangeHandler.bind(this)
    };
  }

  init(cvs) {
    this.canvas = cvs;
  }

  get store() {
    return this.app.store;
  }
  undo(dispatch = true) {
    if (UndoManager.getInstance()._currentIndex <= 0) return;

    // 暂存 overlayImage
    const oldOverImage = this.canvas.overlayImage;
    let allData = UndoManager.getInstance().undo();

    // 这句代码会把 this.canvas.overlayImage 干掉
    this.canvas.loadFromDatalessJSON(allData, () => {
      // 水印处理
      if (!this.canvas.overlayImage && oldOverImage) {
        // 重新赋值 oldOverImage
        this.canvas.overlayImage = oldOverImage;
      }
      if (!this.canvas.overlayImage && DocModuler.watermarkOption.text) {
        this.app.setWatermark();
      }

      // 重新渲染
      this.canvas.renderAll();
    });

    if (dispatch) {
      this.app.sender.undo();
    }
  }
  redo(dispatch = true) {
    let ins = UndoManager.getInstance();
    if (ins._dataCache.length - 1 - ins._currentIndex <= 0) return;

    // 暂存 overlayImage
    const oldOverImage = this.canvas.overlayImage;

    let allData = UndoManager.getInstance().redo();
    this.canvas.loadFromDatalessJSON(allData, () => {
      // 水印处理
      if (!this.canvas.overlayImage && oldOverImage) {
        // 重新赋值 oldOverImage
        this.canvas.overlayImage = oldOverImage;
      }
      if (!this.canvas.overlayImage && DocModuler.watermarkOption.text) {
        this.app.setWatermark();
      }
      // 重新渲染
      this.canvas.renderAll();
    });

    if (dispatch) {
      this.app.sender.redo();
    }
  }

  /**
   * 添加舞台监听
   */
  addEvents() {
    // this.canvas.on(CanvasEventType.Add, this.e.addHandler);
    this.canvas.on(CanvasEventType.Modified, this.e.modifyHandler);
    this.canvas.on(CanvasEventType.Remove, this.e.removeHandler);
    this.canvas.on(CanvasEventType.Selected, this.e.selectedHandler);
    this.canvas.on(CanvasEventType.Deselected, this.e.deselectedHandler);
    this.canvas.on(CanvasEventType.SelectChanged, this.e.selectChangeHandler);
  }

  /**
   * 移除舞台监听
   */
  removeEvents() {
    this.canvas.off(CanvasEventType.Modified, this.e.modifyHandler);
    this.canvas.off(CanvasEventType.Remove, this.e.removeHandler);
    this.canvas.off(CanvasEventType.Selected, this.e.selectedHandler);
    this.canvas.off(CanvasEventType.Deselected, this.e.deselectedHandler);
    this.canvas.off(CanvasEventType.SelectChanged, this.e.selectChangeHandler);
  }

  // by data
  add(data) {
    let factory = this.app.graphicFactory;
    let obj = factory.createByData(data);
    let exist = getObjectByUUID(this.canvas, data['uuid']) !== null;
    if (this.canvas) {
      // 这里使用防抖处理，因为观看端收到消息的顺序不能一定是正确的。可能是 add1,add2,modify1 modify2,这种形式，这样会导致1被删除，修改时找不到，出现文字丢失问题
      // 防抖延迟5000是结合具体测试出来的消息到达的时间结果，评估设置的
      this._debouncedRemoveAllPlaceholderText();
    }

    if (obj && !exist) {
      // 暂存 object:add 事件执行绑定数组[false,f,false,-1:false] (可能是undefined)
      const originBindArr = this.canvas.__eventListeners[CanvasEventType.Add];
      // 重置为 undefined 不让 object:adaded 事件执行，因为后面 add 数据会触发该事件
      this.canvas.__eventListeners[CanvasEventType.Add] = undefined;
      // 添加数据到 canvas
      this.canvas.add(obj);
      // 还原回去
      if (originBindArr) {
        this.canvas.__eventListeners[CanvasEventType.Add] = originBindArr;
      }

      // 主持端只把荧光笔 *remove加入到UndoManager,所以接收端不把荧光笔的 *add加入到UndoManager
      if (obj.gtype != 2) {
        let allData = this.app.stage.root.toDatalessJSON();
        UndoManager.getInstance().save(allData);
      }
      this.canvas.renderAll();
    }
  }

  _debouncedRemoveAllPlaceholderText = debounce(this._removeAllPlaceholderText, REMOVE_ALL_PLACEHOLDER_TEXT_DELAY);

  _removeAllPlaceholderText() {
    this.canvas.forEachObject(item => {
      if (item.gtype === 6 && item.text === '请输入文本') {
        this.canvas.remove(item);
      }
    });
  }

  modify(data) {
    this.canvas.off(CanvasEventType.Modified);
    let factory = this.app.graphicFactory;
    factory.modifyByData(data);

    let allData = this.app.stage.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
    this.canvas.on(CanvasEventType.Modified, this.e.modifyHandler);
    this.canvas.renderAll();
  }

  remove(data) {
    this.canvas.off(CanvasEventType.Remove);
    let factory = this.app.graphicFactory;
    factory.removeByData(data);
    let allData = this.app.stage.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
    this.canvas.on(CanvasEventType.Remove, this.e.removeHandler);
    this.canvas.renderAll();
  }

  removeAll(withEvent = true) {
    if (this.canvas && this.canvas.getObjects().length > 0) {
      this.canvas.off(CanvasEventType.Remove);

      // 记录一下当前想保留的状态，因为清空的时候， 会把设置的属性也一并清空，清空后，再还原一下想要的属性
      // let color = this.canvas.backgroundColor;
      // this.canvas.clear();
      // this.canvas.backgroundColor = color;
      // this.canvas.renderAll();
      this.canvas.remove(...this.canvas.getObjects());
      this.canvas.renderAll();
      this.canvas.on(CanvasEventType.Remove, this.e.removeHandler);
      if (withEvent) {
        let pageId = this.store.getKV('pageId');
        this.app.sender.removeAll({ pageId });
      }
    }
  }

  // _addHandler(e) {
  //     let data = GraphicFactory.createAddData(e.target);
  // }

  _modifyHandler(e) {
    if (!e.target) return;
    if (e.target.gtype == 6 && e.target.isRaw && (!e.target.text || e.target.text === e.target.placeholder)) {
      return;
    }
    log.info('modify item, ', e);
    let factory = this.app.graphicFactory;
    if (e.target.gtype == 6 && e.target.isRaw) {
      e.target.isRaw = false;
      let data = factory.createAddData(e.target);
      this.app.sender.add(data);
    } else {
      let data = factory.createModifyData(e.target);
      this.app.sender.modify(data);
    }
    let allData = this.app.stage.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
    this.canvas.renderAll();
  }

  _removeHandler(e) {
    if (!e.target) return;
    if (e.target.gtype == 6 && e.target.isRaw) {
      return;
    }
    log.info('[doc] remove item, ', e);
    let factory = this.app.graphicFactory;
    let data = factory.createRemoveData(e.target);
    this.app.sender.remove(data);
    let allData = this.app.stage.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
    this.canvas.renderAll();
  }

  _selectHandler(e) {
    log.info('select Item', e);
    let data = {};
    data.uuid = e.selected[0].uuid;
    data.pageId = this.store.getKV('pageId');
    this.app.sender.selected(data);
    this.canvas.renderAll();
  }

  _deselectHandler(e) {
    let data = {};
    // remove的时候， 并不会返回取消选择列表，  而是直接返回取消元素
    if (e.deselected) {
      data.uuid = e.deselected[0].uuid;
    } else {
      data.uuid = e.target.uuid;
    }
    data.pageId = this.store.getKV('pageId');
    log.info('deselect Item', e);
    this.app.sender.deselected(data);
    this.canvas.renderAll();
  }

  _selectChangeHandler(e) {
    let data = {};
    let oldItem = {};
    oldItem.uuid = e.deselected[0].uuid;
    let newItem = {};
    newItem.uuid = e.selected[0].uuid;
    data.oldItem = oldItem;
    data.newItem = newItem;
    data.pageId = this.store.getKV('pageId');
    log.info('select changed old target: ', e.deselected, ' new target: ', e.selected);
    this.app.sender.selectChange(data);
    this.canvas.renderAll();
  }

  _addByHand(e) {
    log.info('--_addByHand', e);
    if (!e.target) {
      return;
    }

    let pen = e.target;
    let data = this.graphicFactory.createAddData(pen);
    // MsgSender.add(data)
    this.sender.add(data);
    let allData = this.stage.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
    this.canvas.renderAll();
  }
}
